import { Fragment } from "react/jsx-runtime";

import { useCluster } from "#modules/cluster/view/useCluster";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { ProcessStepFromQuoteRequestLine } from "#modules/similarPart/view/clustering/CompareCard";
import { CompareProcessStepLines } from "#modules/similarPart/view/clustering/CompareProcessStepLines";
import { normalizeProductLines } from "#shared/helpers/normalizeProductLines";
import { Flex } from "#shared/view/components/Flex";
import { Text } from "#shared/view/components/Text";
import { computeProcessesPrice, formatPriceString, NO_OPTIMIZED_MACHINE_TIMES } from "shared";

export const ProcessStepsCategory = ({
  title,
  processSteps,
  quantity,
  quoteRequestLine,
  sourceQuoteRequestLine,
}: {
  title: string;
  processSteps: ProcessStepFromQuoteRequestLine[];
  quantity: number;
  quoteRequestLine: QuoteRequestLineDto;
  sourceQuoteRequestLine: QuoteRequestLineDto;
}) => {
  const { cluster } = useCluster(sourceQuoteRequestLine.cluster?.id);
  const excludedProcessStepsIds = cluster?.excludedProcessSteps.map(
    (processStepExcluded) => processStepExcluded.id,
  );

  const processStepsMinusExcluded = processSteps
    .filter((processStep) => !excludedProcessStepsIds?.includes(processStep.id))
    .map((processStep) => {
      const normalizedProductLines = normalizeProductLines({
        productLines: processStep.productLines,
        quoteRequestLineQuantity: quantity,
      });

      return {
        ...processStep,
        productLines: normalizedProductLines,
      };
    });

  const { partProcessesCost } = computeProcessesPrice({
    quantity,
    reworkRatio: quoteRequestLine.reworkRatio,
    quantityInAssembly: quoteRequestLine.part.quantityInAssembly,
    addedValueMarginRatio: quoteRequestLine.addedValueMarginRatio,
    productsMarginRatio: quoteRequestLine.productsMarginRatio,
    processSteps: processStepsMinusExcluded,
    optimizedMachineTimes: NO_OPTIMIZED_MACHINE_TIMES,
  });

  return (
    <Fragment>
      <Flex justify={"space-between"} align={"center"}>
        <Text>{title}</Text>
        <Text>
          {formatPriceString({
            amount: partProcessesCost / 100,
            config: {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            },
          })}
        </Text>
      </Flex>

      <CompareProcessStepLines
        processSteps={processSteps}
        selectedQuoteRequestLine={quoteRequestLine}
        sourceQuoteRequestLine={sourceQuoteRequestLine}
      />
    </Fragment>
  );
};
